import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader, MenuItem, Paper, TablePagination
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import DateFnsUtils from '@date-io/date-fns';
import xlsx from 'json-as-xlsx';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { useAlert } from 'react-alert';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },
}));

const screenCode = 'INACTIVECUSTOMERDETAILS';

export default function InactiveCustomerReport(props) {
  const [title] = useState("Inactive Customer Details Report");
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [inactiveCustomerDetail, setinactiveCustomerDetail] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    registrationNumber: '',
    year: '',
    month: ''
  });
  const [FactoryList, setFactoryList] = useState([]);
  const [GroupList, setGroupList] = useState([]);
  const [RouteList, setRouteList] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [inactiveCustomerData, setinactiveCustomerData] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const navigate = useNavigate();
  const [csvHeaders] = useState([])
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
    routeName: "0",
    registrationNumber: '',
    monthName: '',
    year: '',
  })
  const componentRef = useRef();
  const alert = useAlert();
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };
  useEffect(() => {
    trackPromise(
      getPermission()
    );
    trackPromise(
      getGroupsForDropdown(),
    );
  }, []);

  useEffect(() => {
    getFactoriesForDropdown();
  }, [inactiveCustomerDetail.groupID]);

  useEffect(() => {
    getRoutesByFactoryID([]);
  }, [inactiveCustomerDetail.factoryID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWINACTIVECUSTOMERDETAILS');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setinactiveCustomerDetail({
      ...inactiveCustomerDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(inactiveCustomerDetail.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routes = await services.getRoutesForDropDown(inactiveCustomerDetail.factoryID);
    setRouteList(routes);
  }

  async function GetDetails() {
    let model = {
      groupID: parseInt(inactiveCustomerDetail.groupID),
      factoryID: parseInt(inactiveCustomerDetail.factoryID),
      routeID: parseInt(inactiveCustomerDetail.routeID),
      registrationNumber: inactiveCustomerDetail.registrationNumber,
      applicableMonth: moment(selectedDate).format('MM'),
      applicableYear: moment(selectedDate).format('YYYY')
    }
    getSelectedDropdownValuesForReport(model);

    const customerData = await services.GetInactiveCustomerDetails(model);
    if (customerData.data.length > 0) {
      setinactiveCustomerData(customerData.data);

    }
    else {
      alert.error("No Data Found");
    }
  }
  async function createDataForExcel(array) {
    var res = [];

    if (array != null) {
      array.map(x => {
        var vr = {
          'Route': x.routeName,
          'Registration Number': x.registrationNumber,
          'Customer Name': x.name,
          'Last Supply Month': parseInt(moment(x.lastSupplyMonth).format('YYYY')) == 1 ? '-' : moment(x.lastSupplyMonth).format('MMMM YYYY'),
          'Balance(RS)': x.balance,
        }
        res.push(vr);
      });
    }
    var vr = {
      'Route': "Total",
      'Balance(RS)': inactiveCustomerData.reduce((sum, row) => sum + row.balance, 0)
    }
    res.push(vr)
    res.push({})
    var vr = {
      'Route': "Group: " + selectedSearchValues.groupName,
      'Registration Number': "Factory: " + selectedSearchValues.factoryName,
      'Customer Name': selectedSearchValues.routeName ? "Route: " + selectedSearchValues.routeName : "Route: " + "All Routes",

    }
    res.push(vr)

    res.push({
      'Route': "Month : " + moment(selectedDate).format('MMMM'),
      'Registration Number': "Year : " + selectedSearchValues.year,
    })
    return res;
  }

  async function createFile() {
    var file = await createDataForExcel(inactiveCustomerData);
    var settings = {
      sheetName: 'Inactive Customer Report',
      fileName: 'Inactive Customer Report - ' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.factoryName + ' - ' + selectedSearchValues.monthName + ' - ' + inactiveCustomerDetail.year,
      writeOptions: {}
    }
    let keys = Object.keys(file[0])
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })
    let dataA = [
      {
        sheet: 'Inactive Customer Report',
        columns: tempcsvHeaders,
        content: file
      }
    ]
    xlsx(dataA, settings);
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  const getPageMargins = () => {
    return `@media print {
        @page {
            size: A4 Protrait ;
            background-color: white !important;
            padding:2px
        }
   
        body {
            size: A4 Protrait ;
            background-color: white !important;
        }
    }`;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setinactiveCustomerDetail({
      ...inactiveCustomerDetail,
      [e.target.name]: value
    });
    setinactiveCustomerData([]);
  }

  function handleDateChange(date) {
    let monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var month = date.getUTCMonth() + 1;
    var year = date.getUTCFullYear();
    var currentmonth = moment().format('MM');
    let monthName = monthNames[month - 1];

    setSelectedSearchValues({
      ...selectedSearchValues,
      monthName: monthName,
      year: year.toString(),
    });

    setinactiveCustomerDetail({
      ...inactiveCustomerDetail,
      month: month.toString(),
      year: year.toString()
    });
    setSelectedDate(date);
    setinactiveCustomerData([]);
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[searchForm.groupID],
      factoryName: FactoryList[searchForm.factoryID],
      routeName: RouteList[searchForm.routeID],
      registrationNumber: searchForm.registrationNumber,
      month: moment(searchForm.month).format('MMMM'),
      year: moment(searchForm.year).format('YYYY')
    })
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  return (
    <Fragment>
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: inactiveCustomerDetail.groupID,
              factoryID: inactiveCustomerDetail.factoryID,
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group required').min("1", 'Group required'),
                factoryID: Yup.number().required('Factory required').min("1", 'Factory required'),
              })
            }
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={inactiveCustomerDetail.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={inactiveCustomerDetail.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField select
                              fullWidth
                              name="routeID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={inactiveCustomerDetail.routeID}
                              variant="outlined"
                              id="routeID"
                              size='small'
                            >
                              <MenuItem value="0">--Select Routes--</MenuItem>
                              {generateDropDownMenu(RouteList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="registrationNumber">
                              Registration Number
                            </InputLabel>
                            <TextField
                              fullWidth
                              name="registrationNumber"
                              size='small'
                              onChange={(e) => handleChange(e)}
                              value={inactiveCustomerDetail.registrationNumber}
                              variant="outlined"
                              id="registrationNumber"
                            >
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker
                                autoOk
                                variant="inline"
                                openTo="month"
                                views={["year", "month"]}
                                label="Year and Month *"
                                helperText="Select applicable month"
                                value={selectedDate}
                                onChange={(date) => handleDateChange(date)}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                        <Grid container justify="flex-end">
                          <Box pt={2}>
                            <Button
                              color="primary"
                              variant="contained"
                              type='submit'
                              onClick={() => trackPromise(GetDetails())}
                            >
                              Search
                            </Button>
                          </Box>
                        </Grid>
                      </CardContent>
                      {inactiveCustomerData.length > 0 ?
                        <Box minWidth={1050}>
                          <TableContainer component={Paper}>
                            <Table className={classes.table} aria-label="simple table">

                              <TableHead>
                                <TableRow style={{ border: "2px solid black" }}>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px', width: '20%' }}>Route</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px', width: '20%' }}>Registration Number</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px', width: '20%' }}>Customer Name</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px', width: '20%' }}>Last Supply Month</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px', width: '20%' }}>Balance (RS)</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {inactiveCustomerData.slice(page * limit, page * limit + limit).map((row, i) => (
                                  <TableRow style={{ border: "2px solid black" }} key={i}>
                                    <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black", width: '20%' }}> {row.routeName}</TableCell>
                                    <TableCell component="th" scope="row" align="center" style={{ border: "2px solid black", width: '20%' }}> {row.registrationNumber}</TableCell>
                                    <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black", width: '20%' }}> {row.name}</TableCell>
                                    <TableCell component="th" scope="row" align="center" style={{ border: "2px solid black", width: '20%' }}> {parseInt(moment(row.lastSupplyMonth).format('YYYY')) == 1 ? '-' : moment(row.lastSupplyMonth).format('MMMM YYYY')}</TableCell>
                                    <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black", width: '20%' }}>
                                      {row.balance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                              <TableRow>
                                <TableCell align="left" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px', width: '20%', color: 'red' }}>Total </TableCell>
                                <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black", width: '20%' }}></TableCell>
                                <TableCell component="th" scope="row" align="center" style={{ border: "2px solid black", width: '20%' }}></TableCell>
                                <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black", width: '20%' }}></TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black", width: '20%' }}>{inactiveCustomerData.reduce((sum, row) => sum + row.balance, 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2})}</TableCell>
                              </TableRow>
                            </Table>
                            <TablePagination
                              component="div"
                              count={inactiveCustomerData.length}
                              onChangePage={handlePageChange}
                              onChangeRowsPerPage={handleLimitChange}
                              page={page}
                              rowsPerPage={limit}
                              rowsPerPageOptions={[5, 10, 25]}
                            />
                          </TableContainer>
                        </Box> : null}
                      {inactiveCustomerData.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={createFile}
                            size='small'
                          >
                            EXCEL
                          </Button>
                          <ReactToPrint
                            documentTitle={'Inactive Customer Report - ' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.factoryName + ' - ' + selectedSearchValues.monthName + ' - ' + inactiveCustomerDetail.year}
                            trigger={() => <Button
                              color="primary"
                              id="btnRecord"
                              type="submit"
                              variant="contained" s
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}
                              size='small'
                            >
                              PDF
                            </Button>}
                            pageStyle={getPageMargins()}
                            content={() => componentRef.current}
                          />
                          <div hidden={true}>
                            <CreatePDF ref={componentRef}
                              searchData={selectedSearchValues} inactiveCustomerData={inactiveCustomerData} inactiveCustomerDetail={inactiveCustomerDetail} selectDate={selectedDate}
                            />
                          </div>
                        </Box> : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
